/*
 * Office allows only ONE DialogParentMessageReceived handler per dialog
 * window (a second addHandlerAsync call may replace rather than add — see
 * useDialogSlideTemplates.ts's module comment). That single handler already
 * lives in useDialogSlideTemplates.ts (mounted for the whole dialog lifetime,
 * regardless of which Asset Library tab is active), so brand-templates
 * replies arriving on it are forwarded here instead of a second registration.
 * useDialogBrandTemplates.ts subscribes to this in-memory bridge for its state.
 */

import type { PaneToDialogMessage } from "./assetLibraryDialogChannel";

export type BrandChannelMessage = Extract<
  PaneToDialogMessage,
  { type: "brand-templates-ready" | "brand-templates-error" | "brand-insert-done" | "brand-insert-error" }
>;

type Listener = (message: BrandChannelMessage) => void;

const listeners = new Set<Listener>();

/** Called by useDialogSlideTemplates.ts's single message handler. */
export function forwardBrandMessage(message: BrandChannelMessage): void {
  for (const listener of listeners) listener(message);
}

/** Subscribe to brand-templates replies. Returns an unsubscribe for effect cleanup. */
export function subscribeBrandChannel(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
